import request from '@/utils/request'

// 供应商选项数据
export function findSupplierOptions() {
  return request({
    url: `/customer/oc_supplier/options`,
    method: 'get'
  })
}
